module.exports = __webpack_public_path__ + "static/media/lazy_river.b8330d91.jpeg";